import fromString from './fromString'
import toStringBRL from './toStringBRL'

/**
 * referência: https://www.npmjs.com/package/vuejs-dialog
 */

export default {
    fromString,
    toStringBRL,
}
